<template>
  <PageContent id="disclaimer">
    <template slot="heading-title">ComReg Coverage Map Disclaimer</template>
    <div class="container" slot="content">
      <div class="disclaimer">
        <div class="disclaimer-text rich-text" v-html="disclaimer.text"></div>
      </div>
      <div class="back-to-top-container">
        <BackToTop selector="#disclaimer"></BackToTop>
      </div>
    </div>
  </PageContent>
</template>

<script>
import Menu from '@/components/custom/Menu';
import CustomMap from '@/components/custom/CustomMap';
import BackToTop from '@/components/custom/BackToTop';
import PageContent from '@/components/abstract/PageContent';
import { mapGetters, mapActions } from 'vuex';
import { DISCLAIMER } from '@/enum/screens.enum';

export default {
  data () {
    return {};
  },
  components: { Menu, CustomMap, PageContent, BackToTop },
  computed: {
    ...mapGetters('map', ['disclaimer'])
  },
  methods: {
    ...mapActions('map', ['loadDisclaimer', 'screenVisited'])
  },
  mounted() {
    this.loadDisclaimer();
    this.screenVisited({ screen: DISCLAIMER });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import 'nib'

.disclaimer
  column()
  flex-grow 1
  width 100%
  padding 65px
  box-sizing border-box
  @media screen and (max-width 768px)
    padding 10px
  &-text
    overflow hidden

.container
  width 1200px
  margin 40px auto
  max-width 100%
  background #FFFFFF
  padding 65px
  relative top left
  box-sizing border-box
  @media screen and (max-width 768px)
    padding 15px
    padding-bottom 65px

.back-to-top-container
  absolute bottom 30px right 65px

</style>



// WEBPACK FOOTER //
// src/components/pages/Disclaimer.vue